import styles from './totalAmountSection.module.css'
import { useMemo } from 'react'
import { InfoSection } from './infoSection'
import { useDataTypesHooks } from '../../../data-types'

type Props = {
    totalAmount: number
    loaded: boolean
    label?: string
}

export const TotalAmountSection = (props: Props) => {
    const { totalAmount, loaded, label } = props

    const { formatPrice } = useDataTypesHooks()

    const infoContent = useMemo(() => (
        <div className={styles.info}>
            <span>{label || 'Total Transacciones'}</span>
            <span>{formatPrice(totalAmount)}</span>
        </div>
    ), [totalAmount])

    return (
        <InfoSection
            content={infoContent}
            loaded={loaded}
        />
    )
}
